import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=a469c1a4&scoped=true"
import script from "./Reasons.vue?vue&type=script&lang=ts"
export * from "./Reasons.vue?vue&type=script&lang=ts"
import style0 from "./Reasons.vue?vue&type=style&index=0&id=a469c1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a469c1a4",
  null
  
)

export default component.exports